import { ReactNode, useEffect } from 'react'
import Header from './Header'
import Footer from './Footer'
import api from '@/services/api'
import { Settings } from '@/types'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  useEffect(() => {
    // Load settings and inject CSS custom properties
    api.get<Settings>('/settings')
      .then(settings => {
        if (settings.primary_color) {
          document.documentElement.style.setProperty('--primary-color', settings.primary_color)
        }
        if (settings.secondary_color) {
          document.documentElement.style.setProperty('--secondary-color', settings.secondary_color)
        }
      })
      .catch(err => {
        console.error('Failed to load settings for theming:', err)
        // Keep default CSS variable values from global.css
      })
  }, [])

  return (
    <div className="app-layout">
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default Layout
